import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children, requiredLevel = 1, requiredPermission = null }) => {
    const { isAuthenticated, user, loading, hasPermission } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <div className="spinner mx-auto mb-4"></div>
                    <p className="text-gray-600">Loading...</p>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Check auth level
    if (user.auth_level < requiredLevel) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center max-w-md mx-auto p-6">
                    <div className="text-red-500 text-6xl mb-4">🚫</div>
                    <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
                    <p className="text-gray-600 mb-4">
                        You don't have sufficient privileges to access this page.
                    </p>
                    <div className="bg-gray-100 rounded-lg p-4 text-sm">
                        <p><strong>Your Role:</strong> {user.role}</p>
                        <p><strong>Required Level:</strong> {requiredLevel >= 5 ? 'Admin' : 'Viewer'}</p>
                    </div>
                </div>
            </div>
        );
    }

    // Check specific permission if required
    if (requiredPermission && !hasPermission(requiredPermission)) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center max-w-md mx-auto p-6">
                    <div className="text-red-500 text-6xl mb-4">🚫</div>
                    <h1 className="text-2xl font-bold text-gray-900 mb-2">Permission Denied</h1>
                    <p className="text-gray-600 mb-4">
                        You don't have the required permission to access this feature.
                    </p>
                    <div className="bg-gray-100 rounded-lg p-4 text-sm">
                        <p><strong>Required Permission:</strong> {requiredPermission}</p>
                        <p><strong>Your Role:</strong> {user.role}</p>
                    </div>
                </div>
            </div>
        );
    }

    return children;
};

export default ProtectedRoute;